/** @param {'fr'|'en'} locale */
export function getKarateFormationUi(locale = "fr") {
  const en = locale === "en";
  return {
    pageTitle: en ? "Training" : "Formation",
    pageSubtitle: en
      ? "Learn to work in Shotokan AAMC — in your real environment."
      : "Apprenez à travailler dans Shotokan AAMC — dans votre véritable environnement.",
    myTraining: en ? "My training" : "Ma formation",
    progressLabel: en ? "Overall progress" : "Progression globale",
    lastStep: en ? "Last step" : "Dernière étape",
    continue: en ? "Continue my training" : "Continuer ma formation",
    modulesDone: en ? "Completed modules" : "Modules terminés",
    modulesTodo: en ? "Modules to do" : "Modules à faire",
    replayDiscovery: en ? "Review the discovery tour" : "Revoir la découverte",
    replayIntro: en ? "Review the introduction" : "Revoir l'introduction",
    quitTraining: en ? "Leave training" : "Quitter la formation",
    markComplete: en ? "Mark step complete" : "Marquer l'étape terminée",
    verifiedScreen: en ? "I checked the screen" : "J'ai vérifié l'écran",
    openScreen: en ? "Open screen ↗" : "Ouvrir l'écran ↗",
    newTabHint: en
      ? "The screen will open in a new tab. Keep this Training open so you can return to the instructions."
      : "L'écran s'ouvrira dans un nouvel onglet. Gardez cette Formation ouverte pour pouvoir revenir aux instructions.",
    newTabHintMobile: en
      ? "This screen will open separately so your Training stays available."
      : "Cet écran s'ouvrira séparément afin de conserver votre Formation.",
    next: en ? "Next" : "Suivant",
    previous: en ? "Previous" : "Précédent",
    skip: en ? "Skip" : "Passer",
    start: en ? "Start" : "Commencer",
    see: en ? "See" : "Voir",
    understand: en ? "Understand" : "Comprendre",
    do: en ? "Do" : "Faire",
    loading: en ? "Loading training…" : "Chargement de la formation…",
    sessionError: en
      ? "Training requires an active Hanshi or Sensei session. Sign in again or retry."
      : "La formation requiert une session Hanshi ou Sensei active. Reconnectez-vous ou réessayez.",
    retry: en ? "Retry" : "Réessayer",
    demoSafe: en
      ? "Training mode — read-only or demo actions only. No real data will be changed."
      : "Mode formation — lecture seule ou actions simulées. Aucune donnée réelle ne sera modifiée.",
    loginHint: en ? "Sign in with your role to access your training path." : "Connectez-vous avec votre rôle pour accéder à votre parcours.",
    staticIntroTitle: en ? "Preview paths (coming soon for your role)" : "Aperçu des parcours (bientôt pour votre rôle)",
  };
}

/** Libellés CTA « ouvrir dans un nouvel onglet » selon la route réelle. */
const OPEN_SCREEN_LABELS = {
  "/admin": { fr: "Ouvrir le tableau de bord ↗", en: "Open the dashboard ↗" },
  "/sensei": { fr: "Ouvrir le tableau de bord ↗", en: "Open the dashboard ↗" },
  "/hanshi/membres": { fr: "Ouvrir les membres ↗", en: "Open members ↗" },
  "/hanshi/instructeurs": { fr: "Ouvrir les instructeurs ↗", en: "Open instructors ↗" },
  "/admin/comptes": { fr: "Ouvrir les comptes et accès ↗", en: "Open accounts and access ↗" },
  "/admin/dojos": { fr: "Ouvrir les dojos ↗", en: "Open dojos ↗" },
  "/admin/classes": { fr: "Ouvrir les cours ↗", en: "Open classes ↗" },
  "/admin/presences": { fr: "Ouvrir les présences ↗", en: "Open attendance ↗" },
  "/admin/progression": { fr: "Ouvrir la progression ↗", en: "Open progression ↗" },
  "/admin/documents-preuves": { fr: "Ouvrir les documents ↗", en: "Open documents ↗" },
  "/sensei/classes": { fr: "Ouvrir les cours ↗", en: "Open classes ↗" },
  "/sensei/etudiants": { fr: "Ouvrir les élèves ↗", en: "Open students ↗" },
  "/sensei/presences": { fr: "Ouvrir les présences ↗", en: "Open attendance ↗" },
  "/sensei/progression": { fr: "Ouvrir la progression ↗", en: "Open progression ↗" },
  "/sensei/documents": { fr: "Ouvrir les documents ↗", en: "Open documents ↗" },
  "/mes-informations": { fr: "Ouvrir mon profil ↗", en: "Open my profile ↗" },
};

/**
 * @param {string|null|undefined} route
 * @param {'fr'|'en'} [locale]
 * @returns {string}
 */
export function getFormationOpenScreenLabel(route, locale = "fr") {
  const en = locale === "en";
  const key = String(route || "").split("?")[0];
  const entry = OPEN_SCREEN_LABELS[key];
  if (entry) return en ? entry.en : entry.fr;
  return en ? "Open screen ↗" : "Ouvrir l'écran ↗";
}

/** Liens aide → module formation (BT-GSD-KARATE-FORMATION-001 §8) */
export const FORMATION_HELP_MODULE_LINKS = {
  "admin-comptes": { trackId: "admin", stepId: "admin-04-accounts" },
  "admin-membres": { trackId: "admin", stepId: "admin-02-members" },
  "hanshi-instructeurs": { trackId: "admin", stepId: "admin-03-instructors" },
  "admin-presences": { trackId: "admin", stepId: "admin-07-attendance" },
  "admin-progression": { trackId: "admin", stepId: "admin-08-grades" },
  "admin-examens": { trackId: "admin", stepId: "admin-09-exams" },
  "sensei-etudiants": { trackId: "sensei", stepId: "sensei-03-students" },
  "sensei-presences": { trackId: "sensei", stepId: "sensei-04-attendance" },
  "sensei-progression": { trackId: "sensei", stepId: "sensei-05-progress" },
};

export function formationModuleHref(trackId, stepId) {
  const params = new URLSearchParams({ track: trackId, step: stepId });
  return `/formation?${params.toString()}`;
}
